import React from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray, map, uniqBy} from 'lodash';
import searchHoc from '../components-app/search-wrapper';

const servicesDataKey = 'promotedNetworkList';

const promotedNetworkDialog = ({
    id,
    editMode,
    selectedNetwork,
    networkDialogVisible,
    searchData,
    handleCloseDialog,
    handleNetworkChange,
    handleSubmit,
}) => (
    <Dialog
        header={editMode == false ? 'Add Promoted Network' : 'Update Promoted Network'}
        modal={true}
        style={{width: '50vw'}}
        visible={networkDialogVisible}
        onHide={handleCloseDialog}
    >
        <Dropdown
            filter={true}
            filterBy="label,value"
            filterPlaceholder="Select Promoted Network"
            id={id}
            options={
                isArray(searchData.promotionLists)
                    ? map(uniqBy(searchData.promotionLists), promotedNetwork => ({
                          label: promotedNetwork.name,
                          value: promotedNetwork,
                      }))
                    : []
            }
            showClear={false}
            style={{width: '300px'}}
            value={selectedNetwork}
            onChange={handleNetworkChange}
        />{' '}
        <br />
        <br />
        <Button label={editMode == false ? 'Add Network' : 'Update Network'} onClick={handleSubmit} />
    </Dialog>
);

promotedNetworkDialog.propTypes = {
    editMode: PropTypes.bool.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    handleNetworkChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    networkDialogVisible: PropTypes.bool.isRequired,
    searchData: PropTypes.object.isRequired,
    selectedNetwork: PropTypes.array,
};

export default searchHoc(promotedNetworkDialog, servicesDataKey);
